import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const ToggleClickButton = ({
  onclick,
  label,
  btnVal,
  style,
  type = "checkbox",
  name = "",
}) => {
  const [inputVal, setInputVal] = useState(false);
  useEffect(() => {
    setInputVal(btnVal);
  }, [btnVal]);

  return (
    <button
      className="absenteesBtn"
      style={style}
      onClick={(event) => {
        onclick({ ...event, inputVal: !inputVal });
        setInputVal(!inputVal);
      }}
    >
      <label htmlFor="" className="t-13">
        {label}
      </label>
      <input type={type} name={"name"} checked={inputVal} />
    </button>
  );
};
export default ToggleClickButton;

ToggleClickButton.propTypes = {
  event: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  btnVal: PropTypes.bool,
  type: PropTypes.string,
  name: PropTypes.string,
};
